export default __webpack_public_path__ + "static/media/history.b7671a26.png";